/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
var throttle=function(t,r,a){if(a===void 0){a=false}var e=null;var i=true;return function(){var n=this;var f=a&&i;var l=function(){t.apply(n,arguments);e=null};if(f){i=false;l()}if(!e){e=setTimeout(l,r)}}};export{throttle as t};
//# sourceMappingURL=throttle-bf334cba.js.map